var map = {
	"./img-features-feature-5-accessibility_cn.png": "pRxV",
	"./img-features-feature-5-accessibility_en.png": "fdwo",
	"./img-features-feature-5-accessibility_ja.png": "jLIM",
	"./img-features-feature-5-accessibility_ko.png": "MScR"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90Zi";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features ^\.\/img\-features\-feature\-5\-accessibility_.*\.png$
// module id = 90Zi
// module chunks = 18